import { Input } from "@/components/ui/input";
import { formatMoneyInput } from "@/lib/format";

/** Input de MONTOS en pesos con separador de miles (comas) EN VIVO.
 *  - Muestra "10,000" mientras se teclea; internamente entrega el valor CRUDO (sin comas).
 *  - Solo dígitos y hasta 2 decimales. No afecta cálculos ni lo que se guarda en la BD.
 *  onChange recibe el string crudo (ej. "10000" o "10000.5"), como un input numérico normal. */
export function MoneyInput({ value, onChange, id, "data-testid": testid, ...props }) {
  const handleChange = (e) => {
    let raw = e.target.value.replace(/,/g, "");
    if (raw !== "" && !/^\d*\.?\d{0,2}$/.test(raw)) return;
    raw = raw.replace(/^0+(?=\d)/, ""); // quita ceros a la izquierda (mantiene "0" y "0.xx")
    onChange(raw);
  };
  return (
    <Input
      {...props}
      id={id}
      data-testid={testid}
      type="text"
      inputMode="decimal"
      value={formatMoneyInput(value)}
      onChange={handleChange}
    />
  );
}
